$(function () {
    if ($('#carousel-1').length > 0) {
        $('#nextStep').on('click', function () {
            if ($('#step-1 input, #step-1 select, #step-1 textarea').valid()) {
                $('#step-1').toggle('slow')
                $('#step-2').toggle('slow')
            }
        })

        $('#backStep').on('click', function () {
            $('#step-2').toggle('slow')
            $('#step-1').toggle('slow')
        })
    }
})
